import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M3.625 12a8.375 8.375 0 1 1 16.75 0 8.375 8.375 0 0 1-16.75 0ZM12 2.375a9.625 9.625 0 1 0 0 19.25 9.625 9.625 0 0 0 0-19.25ZM12 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1 2.5a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4Z",
		clipRule: "evenodd"
	})
});
export default SvgInfo;
